/*-- import aliases -----------
'!/...' -> project root
'../js/...' -> js folder root
-----------------------------*/

import { setup } from "../js/core";
setup();

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import "../js/global/_body";
import "../js/global/_header";
// import "../js/global/_headerSide"; Commenting out because of new mobile designs that use _sideNavMobile for now
import "../js/global/_footer";
import "../js/global/_searchFilters";
import "../js/global/_sideNavMobile";
import "../js/global/_sideNavScrolling";
import "../js/global/_siteModals";
import "../js/global/_textTruncate";
import "../js/global/_sidebarResize";

import "../js/components/_accordion";
import "../js/components/_carouselSwiper";
import "../js/components/_eventSchedule";
import "../js/components/_filters";
import "../js/components/_forms";
import "../js/components/_productHeader";
import "../js/components/_productTags";
import "../js/components/_tooltips";
import "../js/components/_stat";
import "../js/components/_viewToggle";
import "../js/components/_dragUploader";
import "../js/components/_collapsibleTable";
import "../js/components/_pageNav";
// import "../js/components/_countdown";
